module.exports = __webpack_public_path__ + "media/images/application/bg2-92bd68ef432ba7aa4fb5b12cd42a20a6.png";